import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=65b3814c&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"
import style0 from "./Redirect.vue?vue&type=style&index=0&id=65b3814c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3814c",
  null
  
)

export default component.exports